export default __webpack_public_path__ + "static/media/arrowtop.558dd19c.svg";